<template>
<div>
	<RelevancePart ref="RelevancePart" @Update="getList()" :powerType="powerType"></RelevancePart>
	<Confirm ref="confirm" @confirm="delConfirm"></Confirm>
	<div class="tableSys vaM_E">
		<div class="navBtn pl1x">
			<div class="tabBar style-tabBar cb active-c-main_E tra-fast_E mt0x">
				<button class="cSub ml1x" v-for="(item,index) in buttonGroup" :key="index" :class="{active:currentIndex==index}" @click="changeBtn(index)">
					<span>{{item.text}}</span>
				</button>
			</div>
		</div>
		<div class="w30pct taR pr1x ml1x_E">
			<button class="cSub fR bdSub boxR pl1x pr1x sizeS hover-bg-highLight" type="button" v-if="relBtn" @click="newRelateInfo">{{getLanguageStr("cmd59","授权")}}</button>
		</div>
	</div>
	<List ref="List" @del="delTip" :entityRelId="entityRelIds[0]"></List>
	<!-- <AddRelateInfo ref="AddRelateInfo" @refreshList='getList'></AddRelateInfo> -->
</div>
</template>
<script>
import * as lib from '@/util/lib.js'
import {mapGetters} from 'vuex'
import {getLanguageStr} from '@/util/language.js'

import List from '@/view/maintain/plant/relate/part/List.vue'
import AddRelateInfo from '@/view/maintain/plant/relate/part/AddRelateInfo.vue'
import RelevancePart from '@/view/maintain/part/RelevancePart.vue';//授权
import Confirm from '@/components/common/ui/Confirm.vue'

import {AssociatedPersonDel} from '@/api/maintain/plant/list.js'
import {delRelatedBus, delRelatedUser} from '@/api/maintain/plant/relative.js'

export default {
	name: 'StationRelateInfo',
	components: {List, AddRelateInfo, Confirm, RelevancePart},
	props:{
    powerType:{//能源类型light,wind
     	 type:String,
      	 default:"light"
    		}
    },
	computed:{
		...mapGetters({
			userInfo:"user/userInfo"
		}),
		relBtn(){
			let buttonPermissions = JSON.parse(window.localStorage.getItem('buttonPermissions'))
			if(this.entityRelIds[0]){
					if (!buttonPermissions.includes('A/B/A14')) {
							return false
							} else {
							return true
					}
				}else{
					if (!buttonPermissions.includes('A/B/A14') && !buttonPermissions.includes('A/B/A17') && !buttonPermissions.includes('A/B/A19')) {
							return false
							} else {
							return true
					}
				}
		},
		activeButtonGroup(){

		}
	},
	data () {
		return {
			currentIndex: 0,
			tempButtonGroup:[],
			buttonGroup: [
			],
			tempButtonGroup:[{text: getLanguageStr('plant277','已授权内部成员'), value: 3}],
			stationId: '',
			systemId: '',
			entityRelIds: [],
			scopedType:0
		}
	},
	methods: {
		getLanguageStr,
		show: function (station) {
			if(this.powerType=='wind'){
				this.buttonGroup=this.tempButtonGroup;
			}else{
				this.buttonGroup=([{text: getLanguageStr('plant275', '已授权商家'), value: 1},{text: getLanguageStr('plant276', '已授权用户'), value: 2}]).concat(this.tempButtonGroup);
			}
			this.stationId = station.stationId
			this.systemId = station.systemId
			this.entityRelIds = [station.entityRelIds]
			this.$nextTick(()=>{
				this.$refs.List.getList({type: this.buttonGroup[this.currentIndex].value, ...station})
			})
			let buttonPermissions = JSON.parse(window.localStorage.getItem('scopePermissions'))
			this.scopedType=buttonPermissions.filter(el=>el.resourceType==1)
			if(buttonPermissions.filter(el=>el.resourceType==1).length){
				this.scopedType=buttonPermissions.filter(el=>el.resourceType==1)[0].scope
			}
		},
		changeBtn (index) {
			this.currentIndex = index
			this.getList()
		},
		getList () {
			this.$refs.List.getList({type: this.buttonGroup[this.currentIndex].value, stationId: this.stationId})
		},
		newRelateInfo () {
			this.$refs.RelevancePart.show([this.stationId], 'single', this.entityRelIds)
		},
		delTip (id) {
			let title = ''
			if (this.buttonGroup[this.currentIndex].value == 1) {
				if(this.entityRelIds[0]){ //外部授权
					title = getLanguageStr('phrase707', '确认将该电站从本商家删除吗？删除后，本商家下所有成员将无法看到该电站但不影响其他商家和用户查看该电站。')
				}else{     //管理者
					title = getLanguageStr('phrase743', '确认要删除该商家和电站的关联吗？删除后，该商家下所有成员都将无法看到该电站。') 
				}
			} else if (this.buttonGroup[this.currentIndex].value == 2) {
				title = getLanguageStr('phrase821', '确认要删除该用户和电站的关联吗？删除后，该用户将无法看到该电站。')
			} else {
				title = getLanguageStr('phrase822', '确认要删除该成员和电站的关联吗？')
			}
			this.$refs.confirm.show({
				text: title,
				id: id
			})
		},
		delConfirm (data) {
			if (this.buttonGroup[this.currentIndex].value == 1) {
				if(this.entityRelIds[0]){ //外部授权
					this.$emit('DelRelBus')
				}else{ //管理者
					 delRelatedBus(this.stationId, data.id).then(res => {
						this.getList()
					}, error => {
						!_.isEmpty(error) && this.$notify(error)
					})
				}
			} else if (this.buttonGroup[this.currentIndex].value == 2) {
				delRelatedUser(this.stationId, data.id).then(res => {
					this.getList()
				}, error => {
					!_.isEmpty(error) && this.$notify(error)
				})
			} else {
					AssociatedPersonDel(this.stationId, data.id).then(res => {
						if(this.scopedType==1&&this.userInfo.userInfo.id==data.id){ //该内部成员数据权限是本人的电站，解除自己后需要关闭详情刷新电站列表
							setTimeout(()=>{
								this.$emit('AfterDelPersonal')
							},100)
						}else{
							this.getList()
						}
					}, error => {
						!_.isEmpty(error) && this.$notify(error)
					})
				
			}
		}
	},
	mounted () {
		lib.fillHeight()
		lib.setScroll($('#filterAdv .content[scroll]'))
	}
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/view/maintain/plant/relate/List.vue